<footer class="site-footer">
  <div class="container">
    <div class="row top-pad">
      <div class="col-12">
        <nav class="footer-links">
          <ul class="row justify-content-center">
            @for (footerItem of footerItems; track footerItem) {
              <li class="col-auto"><a [routerLink]="footerItem.path">{{ footerItem.displayText }}</a></li>
            }
          </ul>
        </nav>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-fit build-info">{{ currentVersion }}
        @if (!isProd) {
          <span> - {{ buildTime | amDateFormat:'HH:mm:ssZZ DD MMM YYYY' }}</span>
        }
      </div>
    </div>
  </div>
</footer>
